import React, { useContext } from "react";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faStar} from '@fortawesome/free-solid-svg-icons';
import '../style.css';
import CruiseDealCard from "../components/CruiseDealCard";
import CruiseDealdata from "../components/CruiseDealData";
import ScrolltoTop from "../components/ScrolltoTop";
import UtmUpdate from "../components/WhatsAppUTMLinkUpdater";
import { CurrencyContext } from "../components/CurrencyContext";

const link = {
    USD:"https://booking.tirun.com/swift/cruise?siid=1035987&lang=1&destinationtype=All&sortColumn=departureDate&sortOrder=asc",
    INR:"https://booking.tirun.com/swift/cruise?siid=1113842&lang=1&destinationtype=All&sortColumn=departureDate&sortOrder=asc"
}


const CruiseDeal =()=>{

const Currency = useContext(CurrencyContext);

    return(
        <>
        <Navbar/>
        <UtmUpdate/>
        <div className="header">
        <div className="offer-alert">
            <div>
             <FontAwesomeIcon icon={faStar} style={{color: "#f0ad4e",marginLeft:'5px'}} />
             <FontAwesomeIcon icon={faStar} style={{color: "#f0ad4e",marginLeft:'5px'}} />
             <FontAwesomeIcon icon={faStar} style={{color: "#f0ad4e",marginLeft:'5px'}} />
             <FontAwesomeIcon icon={faStar} style={{color: "#f0ad4e",marginLeft:'5px'}} />
             <FontAwesomeIcon icon={faStar} style={{color: "#f0ad4e",marginLeft:'5px'}} />
            </div>
        <p>4.8 Overall Rating and 5,00,000+ happy customers</p>
        </div>
        </div>


        <div className="cruisedeal-header">
            <h1>Cruise Deals</h1>
            <p>With TIRUN's exclusive cruise deals, we guarantee you the best price and a cruise experience to cherish through the years. Get the most out of your cruise vacation when you book with us.</p>
            <a href={link[Currency.currencyCode]}><button>VIEW ITINERARIES</button></a>
        </div>

        <div className="Cruise-Deal-Container">
            <CruiseDealCard img={CruiseDealdata[0].img} Destination={CruiseDealdata[0].Destination} Offer={CruiseDealdata[0].Offer} Ship={CruiseDealdata[0].Ship} Brand={CruiseDealdata[0].Brand}  link={CruiseDealdata[0].link[Currency.currencyCode]}/>
            <CruiseDealCard img={CruiseDealdata[1].img} Destination={CruiseDealdata[1].Destination} Offer={CruiseDealdata[1].Offer} Ship={CruiseDealdata[1].Ship} Brand={CruiseDealdata[1].Brand} link={CruiseDealdata[1].link[Currency.currencyCode]}/>
            <CruiseDealCard img={CruiseDealdata[2].img} Destination={CruiseDealdata[2].Destination} Offer={CruiseDealdata[2].Offer} Ship={CruiseDealdata[2].Ship} Brand={CruiseDealdata[2].Brand} link={CruiseDealdata[2].link[Currency.currencyCode]} />
            <CruiseDealCard img={CruiseDealdata[3].img} Destination={CruiseDealdata[3].Destination} Offer={CruiseDealdata[3].Offer} Ship={CruiseDealdata[3].Ship} Brand={CruiseDealdata[3].Brand}  link={CruiseDealdata[3].link[Currency.currencyCode]} />
            <CruiseDealCard img={CruiseDealdata[4].img} Destination={CruiseDealdata[4].Destination} Offer={CruiseDealdata[4].Offer} Ship={CruiseDealdata[4].Ship} Brand={CruiseDealdata[4].Brand} link={CruiseDealdata[4].link[Currency.currencyCode]} />
            <CruiseDealCard img={CruiseDealdata[5].img} Destination={CruiseDealdata[5].Destination} Offer={CruiseDealdata[5].Offer} Ship={CruiseDealdata[5].Ship} Brand={CruiseDealdata[5].Brand} link={CruiseDealdata[5].link[Currency.currencyCode]} />
            <CruiseDealCard img={CruiseDealdata[6].img} Destination={CruiseDealdata[6].Destination} Offer={CruiseDealdata[6].Offer} Ship={CruiseDealdata[6].Ship} Brand={CruiseDealdata[6].Brand} link={CruiseDealdata[6].link[Currency.currencyCode]} />
            <CruiseDealCard img={CruiseDealdata[7].img} Destination={CruiseDealdata[7].Destination} Offer={CruiseDealdata[7].Offer} Ship={CruiseDealdata[7].Ship} Brand={CruiseDealdata[7].Brand} link={CruiseDealdata[7].link[Currency.currencyCode]} />
            {/* <CruiseDealCard img={CruiseDealdata[8].img} Destination={CruiseDealdata[8].Destination} Offer={CruiseDealdata[8].Offer} Ship={CruiseDealdata[8].Ship} Brand={CruiseDealdata[8].Brand} link={CruiseDealdata[8].link} /> */}


        </div>

        <ScrolltoTop/>
        
        <Footer/>
        
        
        </>
    );

}

export default CruiseDeal ;